import { useRecoilState, SetterOrUpdater } from 'recoil';

import { dfiReportBestPracticeResponseState, dfiReportInfoOnLateResponseState } from 'store';
import { ReviewResponse } from '../types';

export const useReviewResponseState = (
  responseType: ReviewResponse
): [string, SetterOrUpdater<string>] => {
  const bestPracticeResponse = useRecoilState(dfiReportBestPracticeResponseState);

  const infoOnLateResponse = useRecoilState(dfiReportInfoOnLateResponseState);

  return responseType === ReviewResponse.BestPracticeResponse
    ? bestPracticeResponse
    : infoOnLateResponse;
};
